import React from 'react';
import { useNavigate } from 'react-router-dom';
import './pages.css';

const ResetPassword = () => {
  const navigate = useNavigate();

  return (
    <div className="reset-password-container">
      <h2>Change Password</h2>
      <p style={{ marginBottom: '1rem', color: '#64748b' }}>
        Password management is now handled through our secure authentication service.
      </p>
      <button className="submit-btn" onClick={() => navigate('/forgot-password')}>
        Reset via email verification
      </button>
    </div>
  );
};

export default ResetPassword;
